import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, EstoquesMedicamentoReducer, EstoquesMedicamentoState } from "./estoques-medicamento-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IEstoqueMedicamentoPagedResponse } from "models/response/estoque-medicamento-paged-response";

const EstoquesMedicamentoContext = createContext<EstoquesMedicamentoState | undefined>(undefined);
const EstoquesMedicamentoContextDispatchContext = createContext({} as any);

const EstoquesMedicamentoProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(EstoquesMedicamentoReducer, {
        estoques: new PaginationResponse<IEstoqueMedicamentoPagedResponse>([], 0, 1, 10, 0),
        estoquePagedRequest: { page: 0, pageSize: 10 },
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as EstoquesMedicamentoState);

    return (
        <EstoquesMedicamentoContext.Provider value={state}>
            <EstoquesMedicamentoContextDispatchContext.Provider value={dispatch}>
                {children}
            </EstoquesMedicamentoContextDispatchContext.Provider>
        </EstoquesMedicamentoContext.Provider>
    );
}

const useEstoquesMedicamentoState = () => {
    const context = useContext(EstoquesMedicamentoContext);
    if (context === undefined) {
        throw new Error('useEstoquesMedicamentoState must be used within a EstoquesMedicamentoProvider');
    }
    return context;
}

const useEstoquesMedicamentoDispatch = () => {
    const context = useContext(EstoquesMedicamentoContextDispatchContext);
    if (context === undefined) {
        throw new Error('useEstoquesMedicamentoDispatch must be used within a EstoquesMedicamentoProvider');
    }
    return context;
}

export { EstoquesMedicamentoProvider, useEstoquesMedicamentoState, useEstoquesMedicamentoDispatch, ACTION_TYPES };
